const KEY_PREFIX = 'flair.auth.loginImageUrl.';

const keyForCurrentHost = (): string => `${KEY_PREFIX}${window.location.host}`;

export const getCachedLoginImageUrl = (): string | null => {
  try {
    return window.localStorage.getItem(keyForCurrentHost());
  } catch {
    return null;
  }
};

export const setCachedLoginImageUrl = (url: string | null): void => {
  try {
    const key = keyForCurrentHost();
    if (url) {
      window.localStorage.setItem(key, url);
    } else {
      window.localStorage.removeItem(key);
    }
  } catch {
    // localStorage unavailable or quota exceeded — caching is a nice-to-have.
  }
};
